import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=c4139fca&scoped=true&"
import script from "./AddAccount.vue?vue&type=script&lang=ts&"
export * from "./AddAccount.vue?vue&type=script&lang=ts&"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=c4139fca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4139fca",
  null
  
)

export default component.exports